/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  ScrollToTopOnMount,
  Hero,
  ExtendedFlex,
} from '../coreui';

import heroBannerImage from '../assets/due-diligence-hero.jpg';
import data from './data';

import DynamicBrowseJoinLink from '../helpers';
import IconCallouts from '../components/IconCallouts';
import CalloutFrameImage from '../components/CalloutFrameImage';
import InvestToday from '../whyReits/components/InvestToday';
import RelatedQueueContent from '../knowledgeCenter/components/RelatedQueueContent';
import Leadership from '../ourStory/components/Leadership';
import Section from '../ioDetails/components/section';
import Graphic3ColCallout from '../components/Graphic3ColCallout';
import Overview from '../investmentOptions/components/overview';
import BrowseLink from '../components/BrowseLink';
import TriPanelSection from '../components/TriPanelSection';
import TriPanelSection1 from '../components/TriPanelSection/components/TriPanelSection1';
import TriPanelSection2 from '../components/TriPanelSection/components/TriPanelSection2';
import FadeIn from '../components/FadeIn';

import actions from './actions';

const MoreComponent = (isLoggedIn) => (
  <ExtendedFlex>
    <DynamicBrowseJoinLink
      isLoggedIn={isLoggedIn}
      anonText="Get Started"
      type="L1"
    />
  </ExtendedFlex>
);

const DueDiligence = ({
  isLoggedIn,
  user,
  leadership,
  getCRETeamList,
}) => {
  useEffect(() => { getCRETeamList(); }, [getCRETeamList]);
  return (
    <>
      <ScrollToTopOnMount />
      <Hero
        image={heroBannerImage}
        header="Investing With Confidence"
        subHeader="Understanding The Due Diligence Process"
        bgPosition="74%"
      />
      <CalloutFrameImage
        bg="white"
        imageType="image"
        alignItems="center"
        {...data.opportunity}
      />
      <Section
        bg="gray.0"
      >
        <Graphic3ColCallout
          title={data.realEstateCompany.title}
          description={data.realEstateCompany.subtitle}
          items={data.realEstateCompany.items}
        />
        <BrowseLink
          isLoggedIn={isLoggedIn}
          anonText="Join Now"
        />
      </Section>
      <IconCallouts
        bg="white"
        moreComponent={MoreComponent(isLoggedIn)}
        {...data.theMarket}
      />
      <Section
        title={data.theProperty.title}
        bg="gray.0"
      >
        <Overview
          title={null}
          subtitle={data.theProperty.subtitle}
          items={data.theProperty.items}
        />
        <FadeIn
          fadeInIndex={5}
        >
          <ExtendedFlex>
            <BrowseLink
              isLoggedIn={isLoggedIn}
              anonText="Join Now"
            />
          </ExtendedFlex>
        </FadeIn>
      </Section>
      <IconCallouts
        bg="white"
        moreComponent={MoreComponent(isLoggedIn)}
        {...data.theInvestment}
      />
      <TriPanelSection>
        <TriPanelSection1
          {...data.professionals.section1}
          link={(
            <DynamicBrowseJoinLink
              isLoggedIn={isLoggedIn}
              anonText="Join Now"
              type="L1"
            />
          )}
        />
        <TriPanelSection2
          topCardBg="gray.0"
          bottomCardBg="gray.12"
          {...data.professionals.section2}
        />
      </TriPanelSection>
      <Leadership
        {...leadership}
      />
      <RelatedQueueContent
        title="Gain New Investing Insight"
        queue="fina"
      />
      <InvestToday
        user={user}
        showPhone
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.homepage.user,
  isLoggedIn: state.app.user.isLoggedIn,
  leadership: state.dueDiligence.leadership,
});

const mapDispatchToProps = (dispatch) => ({
  getCRETeamList: () => {
    dispatch(actions.getCRETeamList());
  },
});

DueDiligence.propTypes = {
  user: PropTypes.object,
  isLoggedIn: PropTypes.bool,
  leadership: PropTypes.shape(Leadership.propTypes),
  getCRETeamList: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(DueDiligence);
